import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { Paper, Typography, Box } from '@mui/material';

const FuturisticAreaChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height={400}>
        <Typography variant="h6" color="textSecondary">No sales data available for the selected period.</Typography>
      </Box>
    );
  }

  const chartData = data.map(item => ({
    name: item.name,
    income: parseFloat(item.income) || 0,
    commission: parseFloat(item.totalCommission) || 0,
  }));

  return (
    <ResponsiveContainer width="100%" height={400}>
      <AreaChart
        data={chartData}
        margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
      >
        <defs>
          <linearGradient id="colorIncome" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8884d8" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#8884d8" stopOpacity={0}/>
          </linearGradient>
          <linearGradient id="colorCommission" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#82ca9d" stopOpacity={0.8}/>
            <stop offset="95%" stopColor="#82ca9d" stopOpacity={0}/>
          </linearGradient>
        </defs>
        <XAxis dataKey="name" stroke="#ccc" />
        <YAxis stroke="#ccc" />
        <CartesianGrid strokeDasharray="3 3" stroke="#555" />
        <Tooltip 
          contentStyle={{ backgroundColor: 'rgba(30, 30, 30, 0.8)', border: '1px solid #555', color: '#fff' }}
          itemStyle={{ color: '#fff' }}
        />
        <Legend wrapperStyle={{ color: '#fff' }} />
        <Area type="monotone" dataKey="income" stroke="#8884d8" fillOpacity={1} fill="url(#colorIncome)" />
        <Area type="monotone" dataKey="commission" stroke="#82ca9d" fillOpacity={1} fill="url(#colorCommission)" />
      </AreaChart>
    </ResponsiveContainer>
  );
};

const Dashboard = ({ data }) => {
  return (
    <Paper sx={{ p: 3, backgroundColor: '#2c2c2c', color: 'white', borderRadius: 2 }}>
      <Typography variant="h5" gutterBottom sx={{ borderBottom: '2px solid #8884d8', paddingBottom: 1, marginBottom: 3 }}>
        Sales Overview
      </Typography>
      <FuturisticAreaChart data={data} />
    </Paper>
  );
};

export default Dashboard;
